import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LazyLoadEvent, SelectItem } from 'primeng';
import { IPageResult } from '../../interfaces/page-result';
import { ITaskFilter } from '../../interfaces/task-filter';
import { EngineiusAreaService, EngineiusRegionService } from '../../services';
import { FilterStateService } from '../../services';
import { InboxBackService } from '../../services';
import { InboxJobsService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { flatten } from '../../utils/flatten';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IEArea } from '../../interfaces/earea';
import { IERegion } from '../../interfaces/eregion';
import moment from 'moment';
import { ITaskInfo } from '../../interfaces/task-info';
import { TaskStatusService } from '../../services/task-status.service';

@Component({
  selector: 'jobs-tasks-grid',
  templateUrl: './jobs-tasks-grid.component.html',
  styleUrls: ['./jobs-inbox.scss'],
  // encapsulation: ViewEncapsulation.None // todo: check why
})
export class JobsTasksGridComponent implements OnInit {
  private subscription: Subscription;

  inboxType_VmeInbox = 1;
  inboxType_SupplierExistingJobs = 2;
  inboxType_CustomerInbox = 3;

  public selectedItem: SelectItem;
  taskTypes: SelectItem[] = [];
  eregions: SelectItem[] = [];
  eareas: SelectItem[] = [];
  taskSteps: SelectItem[] = [];
  taskStatuses: SelectItem[] = [];

  public isLoaded: boolean = false;
  public page: IPageResult<ITaskInfo> = {
    items: [],
    total: 0,
  };
  private readonly itemsPerPageDef = 20;
  private readonly defaultSortField = 'pickupEarliest';
  private readonly defaultSortOrder = 1;

  public event: any;
  public filter: Subject<ITaskFilter>;
  public filterVal: ITaskFilter;

  public organisationTypeId: number = 0;

  @Output() selectedTaskChange: EventEmitter<ITaskInfo>;

  private _inboxType: number;
  private allRegions: IERegion[];

  @Input('inboxType')
  set inboxType(value: number) {
    this._inboxType = value;
  }

  get inboxType(): number {
    return this._inboxType;
  }

  private _customers: SelectItem[] = [];
  @Input('customers')
  set customers(value: SelectItem[]) {
    this._customers = value;
  }

  get customers(): SelectItem[] {
    return this._customers;
  }

  private _suppliers: SelectItem[] = [];
  @Input('suppliers')
  set suppliers(value: SelectItem[]) {
    this._suppliers = value;
  }

  get suppliers(): SelectItem[] {
    return this._suppliers;
  }

  @Output() totalCountChanged: EventEmitter<any>;
  private _totalCount: number;
  set totalCount(value: number) {
    this._totalCount = value;
    this.totalCountChanged.emit(value);
  }

  get totalCount(): number {
    return this._totalCount;
  }

  public showProgress: Boolean = false;

  public isLoading: boolean = false;

  constructor(
    private taskService: TaskService,
    private inboxjobsService: InboxJobsService,
    private engineiusRegionService: EngineiusRegionService,
    private userService: UserService,
    private router: Router,
    private inboxBackService: InboxBackService,
    private filterStateService: FilterStateService,
    private vmeInboxjobsService: VmeInboxJobsService,
    private engineiusAreaService: EngineiusAreaService,
    private taskStatusService: TaskStatusService,
  ) {
    this.selectedTaskChange = new EventEmitter<ITaskInfo>();
    this.totalCountChanged = new EventEmitter<any>();
  }

  protected hasCustomerBookingRole: boolean = false;
  protected hasCustomerPriceRole: boolean = false;
  private async initRoles() {
    this.hasCustomerBookingRole = await this.userService.isUserInRole('CUSTOMER_BOOKING');
    this.hasCustomerPriceRole = await this.userService.isUserInRole('CUSTOMER_PRICE');
  }

  ngOnInit() {
    this.showProgress = true;
    this.initDefaultFilter();
    this.initRoles();

    this.userService.getCurrentUserOrg().then((res) => {
      this.organisationTypeId = res?.organisationTypeId;
      void this.bindERegions();
      void this.bindEAreas();
    });

    if (
      this.filterStateService.taskFilterVal &&
      this.filterStateService.taskFilterVal.filters.inboxType.value == this.inboxType
    ) {
      this.filterVal = Object.assign({}, this.filterStateService.taskFilterVal);
      this.filterStateService.taskFilterVal = null;
    } else {
      this.initDefaultFilter();
    }

    this.taskSteps =
      this.inboxType == this.inboxType_VmeInbox
        ? this.inboxjobsService.taskStepDefSelect.filter((x) => x.value != null)
        : this.inboxjobsService.taskStepDefSelect;

    this.taskStatusService.get().then((res) => {
      console.log('** Task statuses: ', res);
      this.taskStatuses = res;
    });

    this.taskService
      .GetTaskTypes()
      .then((res) => (this.taskTypes = res.map((x) => ({ label: x.name, value: x.id }))));

    this.filter = new Subject<ITaskFilter>();

    // subscribe to filter changes with a debounce time
    this.subscription = this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
      this.showProgress = false;
    });

    // set default filter
    this.filter.next(this.filterVal);
  }

  bindEAreas() {
    if (this.organisationTypeId != 1) {
      return;
    }
    this.engineiusAreaService.getAll().then((res) => {
      if (res != null) {
        res.forEach((item) => {
          this.eareas.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  bindERegions() {
    if (this.organisationTypeId != 1) {
      return;
    }
    this.engineiusRegionService.getAll().then((res) => {
      this.allRegions = res;
      if (res != null) {
        res.forEach((item) => {
          this.eregions.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  filterERegions() {
    const selectedAreas = this.filterVal.filters.eareaIdList.value;

    console.log('REBUILDING REGIONS ', selectedAreas);

    let l = [];
    if (this.allRegions != null) {
      this.allRegions
        .filter(
          (x) =>
            selectedAreas == null ||
            selectedAreas.length == 0 ||
            selectedAreas.includes(x.engineiusAreaId),
        )
        .forEach((item) => {
          l.push({ label: item.name, value: item.id });
        });
    }
    return l;
  }

  populateERegions() {
    this.eregions = this.filterERegions();
  }

  load(filter: ITaskFilter) {
    this.isLoading = true;
    this.taskService.GetLiveTasks(flatten(filter)).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.isLoading = false;

      this.totalCount = result.total;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: this.itemsPerPageDef,
      sortField: this.defaultSortField, // ASC
      sortOrder: this.defaultSortOrder,
      filters: {
        inboxType: { value: this._inboxType },
        from: {},
        to: {},
        taskType: { value: 0 },
        eregionId: { value: 0 },
        regNo: { value: null },
        taskStep: { value: -1 },
        taskStatusList: { value: null },
        isRefresh: { value: false },
        customerId: { value: 0 },
        supplierId: { value: 0 },
        taskTypeList: { value: null },
        actualTaskTypeList: { value: null },
        customerIdList: { value: null },
        supplierIdList: { value: null },
        eregionIdList: { value: null },
        eareaIdList: { value: null },
        taskStepList: { value: null },
        isTrackingData: { value: false },
      },
    };
  }

  onRowSelect(event: any) {
    this.selectedTaskChange.emit(event.data);
  }

  gridUpdate() {
    this.load(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filterVal.filters.isRefresh.value = false;
    this.filter.next(this.filterVal);

    this.deselectTask();
  }

  clearFilter() {
    //table.sortField = '';
    this.initDefaultFilter();
    this.filter.next(this.filterVal);

    this.deselectTask();
  }

  deselectTaskFromInbox() {
    this.selectedItem = null;
  }

  deselectTask() {
    this.selectedItem = null;
    this.selectedTaskChange.emit(null);
  }

  editJob(item, $event) {
    let tabType = null;
    switch (this.inboxType) {
      case this.inboxType_VmeInbox:
        tabType = 6;
        break;
      case this.inboxType_SupplierExistingJobs:
        tabType = 15;
        break;
      case this.inboxType_CustomerInbox:
        tabType = 4;
        break;
    }
    this.filterStateService.taskFilterVal = this.filterVal;

    const url =
      this.inboxType == this.inboxType_VmeInbox
        ? 'app/jobscreen/' + item.jobId
        : 'app/jobscreen/' + item.jobId + '/' + item.orderId;

    if ($event?.ctrlKey || $event?.metaKey) {
      // ctrl was held during click
      window.open(url, '_blank');
    } else {
      void this.router.navigate([url]);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  refresh() {
    this.filterVal.filters.isRefresh.value = true; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);

    this.deselectTask();
  }

  vehicleCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.vehiclesNum);
  }

  itemsCountPostfix(item, value, count) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  getRowColour(rowData: any, index: number) {
    return rowData.cssClass;
  }

  downloadToCSV() {
    this.taskService.downloadLiveTasksToCSV(flatten(this.filterVal));
  }

  getPickupDropoffDiffHours(item, isPickup): string {
    let from = isPickup ? item.pickupEarliestDateTime : item.dropoffEarliestDateTime;
    let to = isPickup ? item.pickupLatestDateTime : item.dropoffLatestDateTime;

    let diff = moment(to).diff(from, 'hours');
    return `${diff}hr`;
  }

  showPriceDetails(item) {
    var param: any = {
      jobId: item.jobId,
      orderId: item.orderId,
      customerId: item.customerInfo.Id,
    };

    if (item.supplierId) {
      param.supplierId = item.supplierId;
    }

    this.router.navigate(['app/pricedetails'], { queryParams: param });
  }

  checkCarryOverAuthorised(item: any) {
    return item.carryOverAuthorised;
  }

  rowIsRoute(item: any) {
    return item.routeRecommendationId != null;
  }
}
